<template>
  <router-link
    :to="{
      name: 'report-details',
      params: { id: report.id },
      state: { backRoute },
    }"
    class="report-card"
  >
    <div class="card-header">
      <p class="project-name">{{ report.project_name }}</p>
      <p class="project-date">{{ formatHumanFriendlyDate(report.date) }}</p>
    </div>

    <div class="card-details">
      <p class="label">Location:</p>
      <p class="project-location">{{ report.project_location }}</p>
    </div>

    <div v-if="isAdmin() && report.contact_opt_in !== undefined" class="detail-item">
      <span class="label">Contact me:</span>
      <AppIcon color="green" size="20" type="check" v-if="report.contact_opt_in" />
      <AppIcon color="grey" size="20" type="x" v-else />
    </div>

    <div class="card-status">
      <AppChip :variant="statusVariant(report.status)">
        {{ statusText(report.status) }}
      </AppChip>
    </div>
  </router-link>
</template>

<script setup>
import { AppChip, AppIcon } from "@/components/ui";
import { isAdmin } from "@/utilities/token";
import { formatHumanFriendlyDate } from "@/utilities/date";

defineProps({
  report: {
    type: Object,
    required: true,
  },
  backRoute: {
    type: Object,
    required: true,
  },
});

const statusVariant = (status) => {
  return status === "completed" || status === true ? "success" : "warning";
};

const statusText = (status) => {
  return status === "completed" ? "Completed" : "Draft";
};
</script>

<style lang="scss" scoped>
.report-card {
  display: block;
  background: $color-white;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid $color-primary;
  text-decoration: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  .card-header {
    margin-bottom: 12px;

    .project-name {
      font-weight: 600;
      font-size: 1.1rem;
      color: $color-black;
    }

    .project-date {
      font-weight: 500;
      font-size: 0.9rem;
      color: $color-grey-3;
    }
  }

  .card-details {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .label {
      color: $color-black;
      font-weight: 600;
      min-width: 70px;
    }

    .project-location {
      font-size: 0.9rem;
      color: $color-grey-3;
    }
  }

  .card-status {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
